export function fancyboxHandler() {
  fancyboxBind();
  fancyboxCarousels();
}


function fancyboxBind() {
  Fancybox.bind('[data-fancybox]', {});
}


function fancyboxCarousels() {

  const propertyCarousel = document.getElementById("property-carousel");

  if (!propertyCarousel) {
    return;
  }

  Carousel(
    document.getElementById("property-carousel"), 
    {
      Thumbs: {
        type: "classic"
      }
    }, 
    {
      Lazyload,
      Thumbs
    }
  ).init();
}

